import React from 'react';
import PropTypes from 'prop-types';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import keycloakConfig from './keycloakConfig';
import config from '../../configs/master';

// Use own check for keycloak url because window.ENV is uninitialized at this moment
const keycloak = new Keycloak({
    ...keycloakConfig,
    url: config.keycloakURL.startsWith('{creds')
        ? process.env.REACT_APP_KEYCLOAK_URL
        : config.keycloakURL,
});

const KeycloakProvider = ({ children }) => (
    <ReactKeycloakProvider authClient={keycloak} initOptions={{ onLoad: 'login-required' }}>
        {children}
    </ReactKeycloakProvider>
);

KeycloakProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default KeycloakProvider;
